import React, { useContext, useState } from 'react';
import { AuthContext } from '../../../../shared/context/auth-context';
import Button from '@mui/material/Button';
import CourseModal from '../../../../shared/components/UIElements/courseModal';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';


import './courseItem.css';


const CourseItem = course => {

  const auth = useContext(AuthContext)


  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => 
    {
      console.log("Modal is closing...");
        setOpen(false);
    }

  return (
    <React.Fragment>
      <main className="main-co-container">
     
        {auth.isLoggedIn && auth.user && auth.user.role === 'admin' && (
          <NavLink to={`/updateCourse/${course.id}`} style={{textDecoration: 'none', color: 'white'}}>Edit</NavLink>
        )}
        
        <div className='co-title'>{course.title}</div>
      
            <div className='co-images-course' onClick={handleOpen}>
              <img src={`${process.env.REACT_APP_ASSET_URL}/${course.image}`} alt={course.title} className='imgs' />
            </div>
             
          <div className='co-img-ddt'>
          <div className='co-d-d-t'>
            <div className='day'>Өдөр: {course.day}</div>
            <div className='date'>Огноо: {course.date}</div>
            <div className='time'>Цаг: {course.time}</div>
          </div>

          <div className='co-location'>
            {course.location}
          </div>
     
        </div>      
      </main>
{/* Modal */}
      <CourseModal show={open} onCancel={handleClose}>
        <main  className='course-modal-container'>  
        <div className='course-modal-title'>
          <h1 className='courseModal_title' >{course.title}</h1>
          <p>Товч танилцуулга:</p>
          <p>{course.intro}</p>
          <p className='courseModal_who'>{course.who} </p>
        </div>


        <div className='course-modal_d-d-t'>
          <div className='day'>Өдөр: {course.day}</div>
          <div className='date'>Огноо: {course.date}</div>
          <div className='time'>Цаг: {course.time}</div>
        </div>


        <div >
          <div className='course-modal-location'>Хаана: {course.location}</div>
        </div>
        </main>
      </CourseModal>
    </React.Fragment>
  )
}
export default CourseItem;



